<app-header></app-header>
<app-sidebar (click)="handleClick()" (collapsedEvent)="receiveCollapsed($event)"></app-sidebar>
<section (click)="handleClick()" [ngClass]="{collapsed: collapedSideBar}" class="main-container">
  <router-outlet>

  </router-outlet>
</section>
